(function() {
    let listElement = document.querySelector(".balast-water__header-anchor");
    let scrollLinkClass = "scroll-to";
    let links = [
        {
            text: "Clean and Monitor",
            id: "clean-and-monitor",
            selector: ".steps-block"
        },
        {
            text: "Contact us",
            id: "contact",
            selector: ".one, .editorial"
        },
        {
            text: "Expert knowledge",
            id: "expert-knowledge",
            selector: ".benefits-block ~ .teaser-list"
        },
        {
            text: "Related articles",
            id: "related-articles",
            selector: ".external-links, .preview-block"
        }
    ];

    if(listElement) {
        links.forEach(link => {
            let element = document.querySelector(link.selector);

            if (element) {
                let li = document.createElement("li");
                let a = document.createElement("a");

                element.id = link.id;

                a.classList.add(scrollLinkClass);
                a.href = "#" + link.id;
                a.innerText = link.text;

                li.classList.add("balast-water__header-anchor-item");

                li.appendChild(a);
                listElement.appendChild(li);
            }
        });
    }
}());